import { useLoadingDialog } from '@rhg/hooks/use-loading-dialog';
import commonMessages from '@rhg/lang/messages/common';
import { ftueQueryString } from '@rhg/utils/constants';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

interface OpenPersonalizingCarePlanProps {
    subtitle?: string;
    onClose?: () => void;
}

export function usePersonalizingCarePlan() {
    const { formatMessage } = useIntl();
    const { query } = useRouter();
    const isFtue = ftueQueryString in query;
    const { openLoadingDialog, isOpen } = useLoadingDialog();

    const openPersonalizingCarePlan = useCallback(
        (options?: OpenPersonalizingCarePlanProps) =>
            openLoadingDialog({
                isInterstitial: true,
                subtitle: options?.subtitle,
                title: isFtue
                    ? formatMessage(
                          commonMessages['common.personalizing_care_plan']
                      )
                    : formatMessage(
                          commonMessages['common.updating_care_plan']
                      ),
                onClose: options?.onClose,
                hasGradientBackground: true,
            }),
        [openLoadingDialog, formatMessage, isFtue]
    );
    return { isOpen, openPersonalizingCarePlan };
}
